import React, { useState } from "react";
import { Icon, Popup, Label } from "semantic-ui-react";

const styles = {
	containerField: {
		display: "flex",
		cursor: "pointer",
	},
	textField: {
		paddingLeft: 10,
		fontSize: "0.8em",
	},
	label: {
		width: 120,
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		cursor: "pointer",
	},
	triggerIcon: {
		position: "relative",
		bottom: 2,
		marginLeft: 3,
	},
};

const textField = (field) => ({
	fontWeight: 600,
	color: field === "Oui" ? "#098827" : field === "Non" ? "#ab1a1a" : "black",
});

const ContainerIconPrescription = ({ icon, iconName, field, extra, secondExtra, conditionToggle, toggleOnClick, popupExtra }) => {
	const [popupIsOpen, setPopupIsOpen] = useState(false);
	const handleToggle = () => {
		toggleOnClick?.();
		setPopupIsOpen(false);
	};

	const renderLabel = () => {
		if (field === true) {
			return (
				<>
					<Icon name={iconName} /> Supprimer
				</>
			);
		}
		if (conditionToggle) {
			return (
				<>
					<Icon name={iconName} /> Ajouter
				</>
			);
		}
		return "Pas d'info suffisante";
	};

	const renderPopupIcon = () => (
		<Popup
			content={
				<div style={styles.popupContent}>
					<span>{popupExtra}</span>
					<br />
					{(field === true || conditionToggle) && (
						<Label style={styles.label} color={field === true ? "red" : "green"} content={renderLabel()} onClick={handleToggle} />
					)}
				</div>
			}
			open={popupIsOpen}
			onClose={() => setPopupIsOpen(false)}
			onOpen={() => setPopupIsOpen(true)}
			position="right center"
			trigger={
				<Icon
					link
					inverted={field === true}
					name={iconName}
					size="small"
					circular
					color={field === true ? "green" : conditionToggle ? "black" : "grey"}
					style={styles.triggerIcon}
				/>
			}
			on="click"
		/>
	);

	const displayIcon = icon ?? renderPopupIcon();
	return (
		<div style={styles.container}>
			{displayIcon}
			{extra && <span style={textField(field)}>{` ${extra.trim()} `}</span>}
			{secondExtra && <span style={textField(field)}>{` - ${secondExtra.trim()} `}</span>}
		</div>
	);
};

export default ContainerIconPrescription;
